import update from "immutability-helper";
import { get } from "lodash";
import { CACHE_ACTIONS } from '~/constants/cache-actions.constants';
import { LocalCacheHandler } from '~/utils/local-cache-handler';

const DEFAULT_STATE = {
  list: [],
  tasks: [],
  isLoading: true,
};

const reducer = (state = DEFAULT_STATE, action) => {
  let newState;
  switch (action.type) {
    case CACHE_ACTIONS.checklists: {
      newState = action.payload;
      break;
    }
    case "LOAD_CHECKLISTS_SUCCESS": {
      newState = update(state, {
        list: {
          $set: (action.payload.data && action.payload.data.data) || [],
        },
        isLoading: {
          $set: false
        }
      });
      break;
    }
    case "CREATE_CHECKLIST_SUCCESS": {
      newState = update(state, {
        list: { $set: [...(state.list || []), get(action, "payload.data.data")] },
      });
      break;
    }
    case "UPDATE_CHECKLIST_SUCCESS": {
      const updatedChecklist = get(action, "payload.data.data");
      newState = update(state, {
        list: {
          $set: [
            ...(state.list || []).map(
              (item) =>
                item.id !== updatedChecklist.id ? item : updatedChecklist
            ),
          ],
        },
      });
      break;
    }
    case "UPDATE_CHECKLIST_ONBOARDING_SUCCESS": {
      const saved = get(action, "payload.data.data");
      newState = update(state, {
        list: {
          $set: (state.list || []).map((item) =>
            item.id !== saved.id ? item : { ...item, onboarding_meeting_at: saved.onboarding_meeting_at }
          ),
        },
      });
      break;
    }
    case "DELETE_CHECKLIST_SUCCESS": {
      newState = update(state, {
        list: { $set: [...(state.list || []).filter((item) => item.id !== action.meta.previousAction.id)] },
      });
      break;
    }
    case "LOAD_CHECKLIST_TASKS_SUCCESS": {
      newState = update(state, {
        tasks: {
          $set: action.payload.data.tasks
        }
      });
      break;
    }
    case "SAVE_CHECKLIST_TASKS_SUCCESS": {
      newState = update(state, {
        tasks: {
          $set: action.payload.data.tasks
        }
      });
      break;
    }
    default:
      newState = state;
  }

  const updateCache = [
    "LOAD_CHECKLISTS_SUCCESS",
    "CREATE_CHECKLIST_SUCCESS",
    "UPDATE_CHECKLIST_SUCCESS",
    "DELETE_CHECKLIST_SUCCESS",
    "LOAD_CHECKLIST_TASKS_SUCCESS",
    "SAVE_CHECKLIST_TASKS_SUCCESS",
  ].includes(action.type);

  if (updateCache) {
    LocalCacheHandler.save({
      pathname: CACHE_ACTIONS.checklists,
      data: newState
    });
  }

  return newState;
};

export default reducer;
